import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestOut from './RequestOut';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, requestOutSuccess, error, message,
  } = state.request;
  return {
    isLoading,
    requestOutSuccess,
    error,
    message,
  };
}

const Styled = withStyles(styles)(RequestOut);

export default connect(
  mapStateToProps,
)(Styled);
